<template>
  <responsive-drawer-header :color="theme.appBar.other.color" :headerBg="theme.appBar.other.bg" noDrawerPushContent>
    <template v-slot:drawer-module-title>{{ mx_moduleTitle }}</template>
    <template v-slot:drawer-subtitle>
      <div>{{ $t('module.wagenbuch.eingabe_assistent') }}</div>
    </template>
    <template v-slot:left-module-title>{{ $t('module.wagenbuch.schadenformular') }}</template>

    <template v-slot:right>
      <confirmation-dialog headerProp="cancel" textProp="module.wagenbuch.cancel_confirmation" to="/wagenbuch">
        <template v-slot:activator="{ on }">
          <v-btn :color="theme.appBar.other.color" icon v-on="on">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </template>
      </confirmation-dialog>
    </template>
  </responsive-drawer-header>
</template>

<script>
import common from '@/mixins/common';
import ResponsiveDrawerHeader from '@/layouts/ResponsiveDrawerHeader.vue';
import ConfirmationDialog from '@/dialogs/ConfirmationDialog.vue';

export default {
  name: 'SchadenFormularHeader',
  mixins: [common],
  components: { ResponsiveDrawerHeader, ConfirmationDialog },

  data() {
    return {
      cancelConfirmationDialog: false,
    };
  },
};
</script>
